import { DIET_MAX_DAYS_COUNT } from '@/const'

export function getRatioN3N6(valueN3: number, valueN6: number) {
  let newValueN3
  let newValueN6
  if (valueN3 > 0) {
    newValueN3 = 1
    newValueN6 = round(valueN6 / valueN3, 1)
  } else {
    newValueN3 = 0
    newValueN6 = valueN6
  }
  return `${newValueN3} : ${newValueN6}`
}

export function polishPlural(
  singularNominativ: string,
  pluralNominativ: string,
  pluralGenitive: string,
  value: number,
) {
  if (value === 1) {
    return singularNominativ
  } else if (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20)) {
    return pluralNominativ
  } else {
    return pluralGenitive
  }
}

export const timeOptions = [
  { text: '00:00', value: '00:00' },
  { text: '00:30', value: '00:30' },
  { text: '01:00', value: '01:00' },
  { text: '01:30', value: '01:30' },
  { text: '02:00', value: '02:00' },
  { text: '02:30', value: '02:30' },
  { text: '03:00', value: '03:00' },
  { text: '03:30', value: '03:30' },
  { text: '04:00', value: '04:00' },
  { text: '04:30', value: '04:30' },
  { text: '05:00', value: '05:00' },
  { text: '05:30', value: '05:30' },
  { text: '06:00', value: '06:00' },
  { text: '06:30', value: '06:30' },
  { text: '07:00', value: '07:00' },
  { text: '07:30', value: '07:30' },
  { text: '08:00', value: '08:00' },
  { text: '08:30', value: '08:30' },
  { text: '09:00', value: '09:00' },
  { text: '09:30', value: '09:30' },
  { text: '10:00', value: '10:00' },
  { text: '10:30', value: '10:30' },
  { text: '11:00', value: '11:00' },
  { text: '11:30', value: '11:30' },
  { text: '12:00', value: '12:00' },
  { text: '12:30', value: '12:30' },
  { text: '13:00', value: '13:00' },
  { text: '13:30', value: '13:30' },
  { text: '14:00', value: '14:00' },
  { text: '14:30', value: '14:30' },
  { text: '15:00', value: '15:00' },
  { text: '15:30', value: '15:30' },
  { text: '16:00', value: '16:00' },
  { text: '16:30', value: '16:30' },
  { text: '17:00', value: '17:00' },
  { text: '17:30', value: '17:30' },
  { text: '18:00', value: '18:00' },
  { text: '18:30', value: '18:30' },
  { text: '19:00', value: '19:00' },
  { text: '19:30', value: '19:30' },
  { text: '20:00', value: '20:00' },
  { text: '20:30', value: '20:30' },
  { text: '21:00', value: '21:00' },
  { text: '21:30', value: '21:30' },
  { text: '22:00', value: '22:00' },
  { text: '22:30', value: '22:30' },
  { text: '23:00', value: '23:00' },
  { text: '23:30', value: '23:30' },
]

export const activityLevelOptions = [
  { text: '(1,25) Leżący w łóżku', value: 1.25 },
  { text: '(1,4) Mało aktywny', value: 1.4 },
  { text: '(1,6) Umiarkowanie aktywny', value: 1.6 },
  { text: '(1,75) Aktywny', value: 1.75 },
  { text: '(2) Bardzo aktywny', value: 2 },
  { text: '(2,3) Sportowiec wyczynowy', value: 2.3 },
]

export const modelDietCategoryMap = {
  nfz: 'NFZDiet',
  patient: 'PatientDiet',
  system: 'SystemDiet',
  university: 'UniversityDiet',
  user: 'UserDiet',
}

export const urlCategoryMap = {
  nfz: 'DietListNFZ',
  patient: 'DietListPatient',
  system: 'DietListSystem',
  university: 'DietListUniversity',
  user: 'DietListUser',
}

export const dishSizes = [
  { text: 'Mały', value: 1 },
  { text: 'Średni', value: 2 },
  { text: 'Duży', value: 3 },
] as const

export const mealTypes = [
  { text: 'Śniadanie', value: 1 },
  { text: 'Drugie śniadanie', value: 2 },
  { text: 'Obiad', value: 3 },
  { text: 'Podwieczorek', value: 4 },
  { text: 'Kolacja', value: 5 },
  { text: 'Przekąska', value: 6 },
] as const

export const dishTypes = [
  { subgroup: 'type', text: 'Sałatka', value: 21 },
  { subgroup: 'type', text: 'Zupa', value: 22 },
  { subgroup: 'type', text: 'Danie główne', value: 23 },
  { subgroup: 'type', text: 'Deser', value: 40 },
  { subgroup: 'type', text: 'Kanapki', value: 24 },
  { subgroup: 'type', text: 'Makarony', value: 25 },
  { subgroup: 'type', text: 'Danie mięsne', value: 26 },
  { subgroup: 'type', text: 'Danie rybne', value: 27 },
  { subgroup: 'type', text: 'Surówka', value: 28 },
  { subgroup: 'region', text: 'Polska', value: 12 },
  { subgroup: 'region', text: 'Włoska', value: 13 },
  { subgroup: 'region', text: 'Azjatycka', value: 14 },
  { subgroup: 'region', text: 'Śródziemnomorska', value: 15 },
  { subgroup: 'kitchenware', text: 'Sokowirówka', value: 42 },
  { subgroup: 'kitchenware', text: 'Piekarnik', value: 16 },
  { subgroup: 'kitchenware', text: 'Blender', value: 17 },
  { subgroup: 'kitchenware', text: 'Mikser', value: 18 },
  { subgroup: 'kitchenware', text: 'Bez obróbki termicznej', value: 19 },
  { subgroup: 'kitchenware', text: 'Kuchenka', value: 20 },
  { subgroup: 'kitchenware', text: 'Brak sprzętu', value: 39 },
  { subgroup: 'specialDiets', text: 'Bez laktozy', value: 6 },
  { subgroup: 'specialDiets', text: 'Bogatoresztkowa', value: 38 },
  { subgroup: 'specialDiets', text: 'Lekkostrawna', value: 7 },
  { subgroup: 'specialDiets', text: 'Płynna', value: 8 },
  { subgroup: 'specialDiets', text: 'DASH', value: 9 },
  { subgroup: 'specialDiets', text: 'Low FODMAP', value: 10 },
  { subgroup: 'specialDiets', text: 'W cukrzycy i insulinooporności', value: 11 },
  { subgroup: 'specialDiets', text: 'Wegańska', value: 51 },
  { subgroup: 'specialDiets', text: 'Wegetariańska', value: 52 },
  { subgroup: 'specialDiets', text: 'Bezglutenowa', value: 54 },
  { subgroup: 'specialDiets', text: 'Bezmleczna', value: 53 },
  { subgroup: 'other', text: 'Dla dzieci', value: 29 },
  { subgroup: 'other', text: 'Na słodko', value: 30 },
  { subgroup: 'other', text: 'Na słono', value: 31 },
  { subgroup: 'other', text: 'Szybki', value: 3 },
  { subgroup: 'other', text: 'Do 4 składników', value: 32 },
  { subgroup: 'other', text: 'Proste przepisy', value: 33 },
  { subgroup: 'other', text: 'Paleo', value: 1 },
  { subgroup: 'other', text: 'Potreningowy', value: 2 },
  { subgroup: 'other', text: 'Fit', value: 4 },
  { subgroup: 'other', text: 'Z niskim IG', value: 5 },
  // { value: 41, text: 'Superfood', subgroup: 'other' },
  { subgroup: 'specialOccasion', text: 'Święta Bożego Narodzenia', value: 34 },
  { subgroup: 'specialOccasion', text: 'Wielkanoc', value: 35 },
  { subgroup: 'specialOccasion', text: 'Do pracy', value: 36 },
  { subgroup: 'specialOccasion', text: 'Do szkoły', value: 37 },
] as const

export const ingredientTags = {
  is_diary_free: 'Bezmleczny',
  is_gluten_free: 'Bezglutenowy',
  is_vegan: 'Wegański',
  is_vegetarian: 'Wegetariański',
}

export const ingredientBases = [
  { text: 'IŻŻ', value: 1 },
  { text: 'USDA', value: 2 },
  { text: 'Markowe', value: 3 },
  { text: 'UK', value: 4 },
  { text: 'CH', value: 5 },
  { text: 'NCCDB', value: 6 },
]

export const groupMap = {
  1: 'Nabiał',
  2: 'Mięso i wyroby mięsne',
  3: 'Ryby i owoce morza',
  4: 'Pieczywo',
  5: 'Zbożowe',
  7: 'Orzechy i ziarna',
  8: 'Napoje',
  9: 'Tłuszcze',
  10: 'Inne',
  11: 'Owoce i Warzywa',
  12: 'Przyprawy i zioła',
  13: 'Suplementy',
}

export const ingredientCategories = [
  { text: 'Nabiał', value: 1 },
  { text: 'Mięso i wyroby mięsne', value: 2 },
  { text: 'Ryby i owoce morza', value: 3 },
  { text: 'Pieczywo', value: 4 },
  { text: 'Zbożowe', value: 5 },
  { text: 'Orzechy i ziarna', value: 7 },
  { text: 'Napoje', value: 8 },
  { text: 'Tłuszcze', value: 9 },
  { text: 'Inne', value: 10 },
  { text: 'Owoce i Warzywa', value: 11 },
  { text: 'Przyprawy i zioła', value: 12 },
  { text: 'Suplementy', value: 13 },
]

export const dayMap = [
  'Poniedziałek',
  'Wtorek',
  'Środa',
  'Czwartek',
  'Piątek',
  'Sobota',
  'Niedziela',
]
export const numericMap = Array.from(
  { length: DIET_MAX_DAYS_COUNT },
  (_, index) => `Dzień ${index + 1}`,
)
export const dayMapShort = ['Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'Sb', 'Nd'] as const

// mainGroup inside vue.js has 0 as id
// but on server side mainGroup is represented as None in UserDiet on group field
export const mainGroup = {
  diets_ids: [],
  id: 0,
  name: 'Katalog główny',
}

export const round = (value: number, decimals: number) => {
  // @ts-expect-error
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
}

export const getIconBySortFn =
  <T>(sortBy: T, sortByReverse: boolean) =>
  (by: T) => {
    if (sortBy === by) {
      if (sortByReverse) {
        return 'expand_more'
      } else {
        return 'expand_less'
      }
    } else {
      return 'unfold_more'
    }
  }

export const clamp = (value: number, min: number, max: number) =>
  Math.max(min, Math.min(value, max))

/** Zamienia nbsp i inne warianty spacji na zwykłą spację (U+0020). */
export const normalizeWhitespace = (text: string): string =>
  text.replace(/\u00a0|\u202f|\u2007/g, ' ').replace(/&nbsp;/gi, ' ')
